var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResubscribedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications-circle",
    d: "M57,48a9,9,0,1,0,9,9A9.01,9.01,0,0,0,57,48Zm0,14.538c-.9,0-1.623-.383-1.72-1.193a.173.173,0,0,1,.173-.191h3.092a.173.173,0,0,1,.173.194C58.607,62.143,57.895,62.538,57,62.538Zm4.24-2.077H52.76a.63.63,0,0,1-.484-1c.707-.837,1.206-1.189,1.206-3.5a3.077,3.077,0,0,1,2.034-3.231.491.491,0,0,0,.274-.289,1.236,1.236,0,0,1,2.423,0,.493.493,0,0,0,.274.289,3.079,3.079,0,0,1,2.034,3.231c0,2.308.5,2.659,1.205,3.5A.632.632,0,0,1,61.24,60.462Z",
    transform: "translate(-48 -48)",
    fill: "#2ec973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResubscribedIcon);
export default __webpack_public_path__ + "static/media/resubscribed-icon.6604213df76ee858160f100dc615ed03.svg";
export { ForwardRef as ReactComponent };